/**
 * Capability codes used by the role gates.
 *
 * These are names only. Which roles hold a capability is data the backend owns
 * (the `RoleCapability` table), delivered on login and from
 * `GET /api/v1/me/capabilities/`. The frontend never decides what a role may
 * do; it asks `useCan(code)` and renders accordingly.
 *
 * Adding a gated surface means adding a code here that the backend already
 * knows about, nothing else.
 */
export const CAPABILITIES = {
  DASHBOARD_VIEW: 'dashboard.view',
  HOSTS_VIEW: 'hosts.view',
  HOSTS_MANAGE: 'hosts.manage',
  MEETINGS_VIEW: 'meetings.view',
  MEETINGS_MANAGE: 'meetings.manage',
  TAKEAWAYS_VIEW: 'takeaways.view',
  BADGE_VIEW: 'badge.view',
  PRODUCTS_VIEW: 'products.view',
  PRODUCTS_MANAGE: 'products.manage',
  COMMUNICATIONS_VIEW: 'communications.view',
  COMMUNICATIONS_MANAGE: 'communications.manage',
  SHOPIFY_VIEW: 'shopify.view',
  SHOPIFY_MANAGE: 'shopify.manage',
  ACCOUNTING_VIEW: 'accounting.view',
  ACCOUNTING_MANAGE: 'accounting.manage',
  PAYMENT_SETUP_MANAGE: 'payment_setup.manage',
  COMMISSION_VIEW: 'commission.view',
  COMMISSION_MANAGE: 'commission.manage',
  APIKEYS_MANAGE: 'apikeys.manage',
  SUBSCRIPTION_VIEW: 'subscription.view',
  SUBSCRIPTION_MANAGE: 'subscription.manage',
  TEAM_MANAGE: 'team.manage',
};
